<template>
    <div class="m-portlet m-portlet--mobile m-portlet--body-progress-">
        <div class="m-portlet__body larger-text" style="height: 457px;overflow: scroll;">
            <div class="m-portlet__body-progress">{{ labels.product_information }}</div>
            <div class="row">
                <div class="col-sm-6">
                    <h4><span v-html="showResult('brandName')"></span> {{ getBrandGroup() }} <span v-html="showIsLeader()"></span></h4>
                    <h4 v-html="showResult('collectionName')"></h4> <!-- CONGLOMERATE -->
                    <h3 v-html="showResult('name')"></h3> <br>

                    <p v-html="showResult('typeName')"></p>
                    <p><span v-html="showResult('categoryName')"></span> <span v-if="previewProduct.areas && previewProduct.areas.length">-</span> {{ displayArray(previewProduct.areas) }}</p>
                    <p>{{ displayArray(previewProduct.typeSkins) }}</p>
                    <p>{{ displayArray(previewProduct.targets)  }}</p>
                    <p>{{ displayArray(previewProduct.typePacks) }} <span v-if="previewProduct.packageCapacities && previewProduct.packageCapacities.length">-</span>{{ displayArray(previewProduct.packageCapacities) }}</p>

                    <p><a v-show="previewProduct.linkWebsite" :href="previewProduct.linkWebsite" target="_blank" style="color: #1b7e9a;">{{ labels.visit_the_site }}</a></p>
                </div>
                <div class="col-sm-6">
                    <p><span class="text_bolder">{{ labels.made_in }} :</span> {{ previewProduct.countryDistribution }}</p>
                    <p><span class="text_bolder">{{ labels.date_commercialized }} :</span> {{ displayDate(previewProduct.dateCommercialized) }}</p>
                    <p><span class="text_bolder">{{ labels.productFilters.distributionChannels }} :</span> {{ previewProduct.distributionChannels.join(', ') }}</p>
                    <p><span class="text_bolder">{{ labels.price }} :</span> {{ previewProduct.price }}</p>
                    <p><span class="text_bolder">{{ labels.last_updated }} :</span> {{ displayDate(previewProduct.dateModification) }} {{ displayTime(previewProduct.dateModification) }} {{ previewProduct.userLastModification }}</p>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <show-files-link-to-object type="brands" :object-id="brandId" labelTitle="file_link_to_object_brand" :withDelete="false"  v-if="brandId"/>
                </div>
                <div class="col-sm-6">
                    <show-files-link-to-object type="collections" :object-id="collectionId" labelTitle="file_link_to_object_collection" :withDelete="false"  v-if="collectionId"/>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ShowFilesLinkToObject from '../../Upload/ShowFilesLinkToObject.vue';
import { HTTP } from '../../../assets/js/axiosConfig';

export default {
  props: ['previewProduct'],
  components: {
    ShowFilesLinkToObject,
  },
  data() {
    return {
      collectionId: null,
      brandId: null,
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
    ...mapGetters([
      'getConglomerateName',
    ]),
  },
  methods: {
    displayArray(array) {
      return array.join(', ');
    },
    displayDate(dateStr) {
      if (dateStr) {
        const date = new Date(dateStr);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}, `;
      }
    },
    displayTime(dateStr) {
      if (dateStr) {
        const date = new Date(dateStr);
        return `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      }
    },
    getBrandGroup() {
      const conglomerate = this.previewProduct.brandName ? this.getConglomerateName(this.previewProduct.brandName) : '';
      return conglomerate ? `(${conglomerate.name})` : '';
    },
    showResult(value) {
      return this.previewProduct._highlightResult.hasOwnProperty(value) ? this.previewProduct._highlightResult[value].value : this.previewProduct[value];
    },
    showIsLeader() {
      return this.previewProduct.isLeader ? "<i class='fa fa-crown' style='font-size: 21px;'></i>" : null;
    },
    getBrutProduct() {
      const my = this;
      HTTP.get(`api/products/${this.previewProduct.productId}`)
        .then((response) => {
          if (response.data) {
            my.collectionId = response.data.collection_id;
            my.brandId = response.data.brand_id;
          }
        })
        .catch((err) => console.log(err));
    },
  },
  mounted() {
    this.getBrutProduct();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Products/Preview/BasicInfo.vue